import React from "react";
import { Link, NavLink } from "react-router-dom";
import { ShoppingBag } from "lucide-react";
import { useCart } from "../context/CartContext";

const links = [
  { to: "/", label: "Home", end: true },
  { to: "/catalog", label: "Catalog" },
  { to: "/shop", label: "Shop" },
  { to: "/tutorials", label: "Tutorials" },
  { to: "/brush-id", label: "Brush ID" },
  { to: "/look-builder", label: "Looks" },
  { href: "https://makeupstudio.pro", label: "Artistry", external: true },
  { to: "/quiz", label: "Brush Finder Quiz" },
  { to: "/blog", label: "Journal" },
  { to: "/free-guide", label: "Guide" },
  { to: "/about", label: "About" },
];

export default function Navbar({ onOpenExpert }) {
  const { count } = useCart();

  return (
    <header
      data-testid="site-nav"
      className="sticky top-0 z-40 backdrop-blur-xl bg-[#F9F7F3]/80 border-b border-[#E5E0D8]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between gap-4">
        <Link to="/" data-testid="nav-logo" className="flex items-baseline gap-2 shrink-0">
          <span className="font-serif-display text-2xl tracking-tight text-stone-900">BrushBasics</span>
          <span className="overline hidden sm:inline">The Guide</span>
        </Link>

        <nav className="hidden md:flex items-center gap-6">
          {links.map((l) => {
            const testId = `nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`;
            if (l.external) {
              return (
                <a
                  key={l.label}
                  href={l.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={testId}
                  className="text-sm tracking-wide text-stone-500 hover:text-stone-900 transition-colors"
                >
                  {l.label}
                </a>
              );
            }
            return (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.end}
                data-testid={testId}
                className={({ isActive }) =>
                  `text-sm tracking-wide transition-colors ${
                    isActive ? "text-stone-900" : "text-stone-500 hover:text-stone-900"
                  }`
                }
              >
                {l.label}
              </NavLink>
            );
          })}
        </nav>

        <div className="flex items-center gap-3">
          <Link
            to="/cart"
            data-testid="nav-cart-btn"
            className="relative inline-flex items-center justify-center w-10 h-10 text-stone-700 hover:text-stone-900 transition-colors"
            aria-label="Cart"
          >
            <ShoppingBag size={18} strokeWidth={1.5} />
            {count > 0 && (
              <span
                data-testid="nav-cart-count"
                className="absolute -top-0.5 -right-0.5 bg-[#8C6A5D] text-white text-[10px] font-medium rounded-full min-w-[18px] h-[18px] inline-flex items-center justify-center px-1"
              >
                {count}
              </span>
            )}
          </Link>
          <button
            data-testid="open-expert-btn"
            onClick={onOpenExpert}
            className="text-xs uppercase tracking-[0.22em] bg-[#8C6A5D] hover:bg-[#70544A] text-white px-3 sm:px-5 py-2.5 transition-colors"
          >
            Ask the Expert
          </button>
        </div>
      </div>
    </header>
  );
}
